import { FormControl, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { pick } from "ramda";
import React from "react";

const useSkeletonStyles = makeStyles((theme) => ({
  skeleton: {
    ...pick(
      ["backgroundColor", "borderRadius", "padding"],
      theme.overrides.MuiOutlinedInput.root,
    ),
    width: "330px",
    height: "63px",
    display: "inline-flex",
    marginBottom: "20px",
  },
}));

const LoadingField = (): React.ReactElement => {
  const classes = useSkeletonStyles();

  return (
    <FormControl>
      <Skeleton
        animation="wave"
        variant="rect"
        role="progressbar"
        className={classes.skeleton}
      />
    </FormControl>
  );
};

export default LoadingField;
